import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { formatPremiumLimits } from '../utils/getPremiumLimits'
import type { SiteDataUsage } from '@wix/ambassador-cloud-data-usage-v1-site-data-usage/types'

export const onPremiumLimitsChange = (
  editorSdkProxy: EditorSDK,
  payload: SiteDataUsage,
): void => {
  editorSdkProxy.editor.updateAppState({
    premiumLimits: formatPremiumLimits(payload),
  })
}
